import React, { Component } from 'react';
import { bool, number, string, } from 'prop-types';

import * as str from '../../../../lib/string_utils';

import cx from 'classnames';
import s from './HealthRecordNotes.css';


export default class HealthRecordNotes extends Component {
  static propTypes = {
    className: string,
    id: string,
    notes: string,
    isCollapsed: bool,
    truncateLength: number,
    scrollLength: number,
  };

  static defaultProps = {
    isCollapsed: true,
    truncateLength: 90,
    scrollLength: 1500,
  };

  constructor(props) {
    super(props);

    this.state = {
      expanded: null, // Notes detail toggles on tap
    };
  }

  // Toggles expand/collapse of Doctor note/message
  handleClick = (e) =>
    this.setState({
      expanded: !this.state.expanded,
    });

  render = () => {
    const {
      className,
      id,
      notes,
      scrollLength,
      truncateLength,
    } = this.props;
    const truncatedNotes = str.ellipsis(notes, truncateLength);
    const notesCount = str.stringCount(notes);
    const hasScrolling = (this.state.expanded && notesCount >= scrollLength ? s.scrollNotes : '');

    // Notes will either be truncated or expanded
    const renderNotes = (this.state.expanded ? notes : truncatedNotes);

    // Do not display the icon for messages <= truncate length
    return (
      <section className={cx(s.component, className)}>
        {notes && notesCount >= truncateLength &&
          <a
            id={id}
            key={id}
            title={(this.state.expanded ? 'Collapse Notes' : 'Show Notes')}
            className={(this.state.expanded ? s.toggleActive : s.toggle)}
            onClick={this.handleClick}
          >
            Show Notes
          </a>
        }
        <div className={s.content}>
          <p className={cx(hasScrolling)}>
            {renderNotes}

            {notes && notesCount >= truncateLength &&
              <a
                className={s.textToggle}
                onClick={this.handleClick}>
                {(this.state.expanded ? 'Collapse' : 'Read More')}
              </a>
            }
          </p>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordNotes/HealthRecordNotes.js